var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCvsDndSmallDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#c8c8c8;stroke:#c8c8c8;stroke-width:.8px}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_sync_cvs_40_disabled",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_68",
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#fff",
    stroke: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M10.415 14.322c.314 0 .568-.178.568-.4s-.254-.4-.568-.4H5.233c-.314 0-.568.178-.568.4s.254.4.568.4z",
    className: "cls-2",
    transform: "translate(12.589 13.885)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    d: "M7.387 0a4.194 4.194 0 0 0-4.108 3.474 3.629 3.629 0 0 0 .32 7.241h8.307v-.656L3.6 9.95a2.87 2.87 0 0 1 0-5.74.38.38 0 0 0 .379-.347A3.438 3.438 0 0 1 7.387.765a3.2 3.2 0 0 1 2.38 1.029.376.376 0 0 0 .408.09 3.028 3.028 0 0 1 1-.161 2.667 2.667 0 0 1 2.652 2.337.382.382 0 0 0 .249.317 2.886 2.886 0 0 1-1.007 5.573l-1.164.109v.656h1.164a3.636 3.636 0 0 0 1.474-6.942A3.432 3.432 0 0 0 11.175.957a3.793 3.793 0 0 0-1.042.155A3.965 3.965 0 0 0 7.387 0z",
    className: "cls-2",
    transform: "translate(11.7 11.307)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    d: "M2.989 11.454c0 .219.254.4.568.4h9.171c.314 0 .568-.178.568-.4s-.254-.4-.568-.4h-9.17c-.314.003-.569.181-.569.4z",
    className: "cls-2",
    transform: "translate(12.27 13.414)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvsDndSmallDisabled);
export default __webpack_public_path__ + "static/media/cvs-dnd-small-disabled.c09c0b1583dfc7fa136ab20704e75c58.svg";
export { ForwardRef as ReactComponent };